import { Card, CardHeader, CardContent } from '@/components/ui/card'

export function NationCardSkeleton() {
  return (
    <Card>
      <CardHeader>
        <div className="bg-muted h-5 w-32 animate-pulse rounded" />
        <div className="bg-muted mt-2 h-4 w-40 animate-pulse rounded" />
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="bg-muted h-4 w-36 animate-pulse rounded" />
          <div className="bg-muted h-4 w-40 animate-pulse rounded" />
          <div className="bg-muted h-4 w-28 animate-pulse rounded" />
        </div>
      </CardContent>
    </Card>
  )
}
